import React, { useState, useContext, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import logo from '../img/logo manejo-03.png';
import '../stylesheets/header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isDiagnosticMenuOpen, setIsDiagnosticMenuOpen] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const userMenuRef = useRef(null);
  const diagnosticMenuRef = useRef(null);

  // Cerrar los menús al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setIsUserMenuOpen(false);
      }
      if (diagnosticMenuRef.current && !diagnosticMenuRef.current.contains(event.target)) {
        setIsDiagnosticMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    logout();
    setIsUserMenuOpen(false);
    setIsMenuOpen(false);
    navigate('/');
  };

  const handleMenuLinkClick = () => {
    setIsMenuOpen(false);
    setIsDiagnosticMenuOpen(false);
    setIsUserMenuOpen(false);
  };

  return (
    <header className="main-header">
      <div className="header-container">
        <div className="logo-container">
          <Link to="/" onClick={handleMenuLinkClick}>
            <img src={logo} alt="Logo Icetex" />
          </Link>
        </div>

        <button 
          className="mobile-nav-toggle" 
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span className="hamburger-middle"></span>
        </button>

        <nav className={`main-nav ${isMenuOpen ? 'mobile-open' : ''}`}>
          <ul>
            <li><Link to="/" onClick={handleMenuLinkClick}>Inicio</Link></li>
            
            {/* Diagnósticos con dropdown */}
            <li className="diagnostic-menu-item" ref={diagnosticMenuRef}>
              <button 
                className="diagnostic-menu-button"
                onClick={() => setIsDiagnosticMenuOpen(!isDiagnosticMenuOpen)}
                aria-expanded={isDiagnosticMenuOpen}
              >
                <span>Asistentes IA</span>
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="14" 
                  height="14" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                  className={`chevron ${isDiagnosticMenuOpen ? 'open' : ''}`}
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
              
              {isDiagnosticMenuOpen && (
                <div className="diagnostic-dropdown">
                  <Link
                    to="/plans/"
                    className="dropdown-item"
                    onClick={handleMenuLinkClick}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="3" y1="9" x2="21" y2="9"></line>
                      <line x1="3" y1="15" x2="21" y2="15"></line>
                      <line x1="9" y1="3" x2="9" y2="21"></line>
                      <line x1="15" y1="3" x2="15" y2="21"></line>
                    </svg>
                    Modelo de Negocios
                  </Link>
                  <Link
                    to="/plans/pmv/"
                    className="dropdown-item"
                    onClick={handleMenuLinkClick}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 11l3 3L22 4"></path>
                      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                    </svg>
                    Validación de Hipótesis PMV
                  </Link>
                  <Link
                    to="/plans/opp/"
                    className="dropdown-item"
                    onClick={handleMenuLinkClick}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="11" cy="11" r="8"></circle>
                      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                    Identificación de Oportunidades
                  </Link>
                  <Link
                    to="/plans/pitch/"
                    className="dropdown-item"
                    onClick={handleMenuLinkClick}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                    </svg>
                    Pitch Profesional
                  </Link>
                </div>
              )}
            </li>
            
            <li><a href="https://comunidad.wirkconsulting.com/" target="_blank" rel="noopener noreferrer" onClick={handleMenuLinkClick}>Formación</a></li>
            <li><Link to="/under-construction/" onClick={handleMenuLinkClick}>Mentoria IA</Link></li>
            <li><Link to="/under-construction/" onClick={handleMenuLinkClick}>Perfil Profesional</Link></li>
            
            {user ? (
              <li className="user-menu-item" ref={userMenuRef}>
                <button 
                  className="user-menu-button"
                  onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                  aria-expanded={isUserMenuOpen}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  <span>{user.full_name}</span>
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="16" 
                    height="16" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    className={`chevron ${isUserMenuOpen ? 'open' : ''}`}
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </button>
                
                {isUserMenuOpen && (
                  <div className="user-dropdown">
                    <Link 
                      to="/change-password/" 
                      className="dropdown-item"
                      onClick={handleMenuLinkClick}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </svg>
                      Cambiar Contraseña
                    </Link>
                    <button 
                      className="dropdown-item logout"
                      onClick={handleLogout}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        <polyline points="16 17 21 12 16 7"></polyline>
                        <line x1="21" y1="12" x2="9" y2="12"></line>
                      </svg>
                      Cerrar Sesión
                    </button>
                  </div>
                )}
              </li>
            ) : (
              <li className="login-item">
                <Link to="/login/" className="login-button" onClick={handleMenuLinkClick}>Iniciar Sesión</Link>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;